import { motion } from "framer-motion";

const services = [
    {
        n: "I",
        title: "Chauffeur · Worldwide",
        copy: "From London; destined for wherever the road leads.",
    },
    {
        n: "II",
        title: "Private Aviation",
        copy: "From short-notice jet charters to helicopter transfers and airside receptions, every movement is precision routed, expertly fuelled and executed to the finest detail.",
    },
    {
        n: "III",
        title: "Yachts & The Sea",
        copy: "Day charters in the Mediterranean to month-long itineraries. Crew, provisioning, mooring, all attended.",
    },
    {
        n: "IV",
        title: "Pet & Vehicle Relocation",
        copy: "From cherished pets to prized classic cars, moved across continents with precision, discretion and care.",
    },
    {
        n: "V",
        title: "Lifestyle Concierge",
        copy: "From discreet reservations and last-minute tickets to private fittings, rare gifts, watches, art and close protection security, seamlessly tailored to your itinerary.",
    },
    {
        n: "VI",
        title: "Unusual Requests",
        copy: "If it can be achieved quietly, elegantly and on schedule, consider it done.",
    },
    {
        n: "VII",
        title: "Villas",
        copy: "Exclusive villas in the world's most desirable destinations.",
    },
];

export default function Services() {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative bg-surface py-24 md:py-40 overflow-hidden"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-8 mb-16 md:mb-24">
                    <div className="col-span-12 md:col-span-4">
                        <span className="font-sans text-[10px] uppercase tracking-[0.4em] text-oxblood">
                            № II - Repertoire
                        </span>
                    </div>
                    <div className="col-span-12 md:col-span-8">
                        <motion.h2
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 1 }}
                            className="font-serif text-[2.2rem] md:text-[3rem] leading-[1.1]"
                        >
                            Seven houses of service.
                            <br />
                            <span className="italic text-oxblood">One singular standard.</span>
                        </motion.h2>
                    </div>
                </div>

                <div className="border-t border-bone">
                    {services.map((s, i) => (
                        <motion.div
                            key={s.n}
                            initial={{ opacity: 0, y: 14 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-50px" }}
                            transition={{ duration: 0.8, delay: i * 0.05 }}
                            data-testid={`service-row-${s.n}`}
                            className="group grid grid-cols-12 gap-6 border-b border-bone py-8 md:py-10 cursor-default transition-colors duration-500 hover:bg-cream"
                        >
                            <div className="col-span-2 md:col-span-1 font-serif italic text-[#595959] text-[18px]">
                                {s.n}.
                            </div>
                            <div className="col-span-10 md:col-span-5 font-serif text-[1.5rem] md:text-[2rem] leading-tight transition-colors duration-500 group-hover:text-oxblood">
                                {s.title}
                            </div>
                            <div className="col-span-12 md:col-span-6 font-sans text-[14px] md:text-[15px] leading-[1.8] text-[#1A1A1A]/75 md:pl-8">
                                {s.copy}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
